import initialState from './initialState';
import { reducer as deletePermissionReducer } from './deletePermission';
import { reducer as getFlagsReducer } from './getFlags';
import { reducer as loadProjectDetailReducer } from './loadProjectDetail';

const reducers = [deletePermissionReducer, getFlagsReducer, loadProjectDetailReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
